import Swiper from 'swiper';

export default function widgetTestimonialsInit() {
    let testimonials = [];

    $('[data-widget-testimonials]').each(function (index, element) {
        let $widget = $(element);
        testimonials[index] = new Swiper($('.swiper-container', element), {
            speed: 500,
            spaceBetween: 56,
            slidesPerView: 'auto',
            navigation: {
                nextEl: $('.swiper-next-btn', $widget),
                prevEl: $('.swiper-prev-btn', $widget)
            },
            breakpoints: {
                1023: {
                    slidesOffsetBefore: 56,
                    slidesOffsetAfter: 56
                },
                767: {
                    slidesOffsetBefore: 45,
                    slidesOffsetAfter: 45,
                    slidesPerView: 'auto',
                    spaceBetween: 40
                },
                599: {
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                    slidesPerView: 'auto',
                    spaceBetween: 30
                }
            },

        });
        // testimonials[index].on('transitionEnd', function(){
        //     if( testimonials[index].translate === -100 ) {
        //         $('.swiper-slide-next').addClass('swiper-slide-active');
        //     } else {
        //         // $('.swiper-slide').removeClass('swiper-slide-active');
        //
        //     }
        // });
        testimonials[index].snapGrid = testimonials[index].slidesGrid.slice(0);
        // testimonials[index].snapGrid[testimonials[index].snapGrid.length - 1] = testimonials[index].slidesGrid[testimonials[index].slidesGrid.length - 1]
    });

    // console.log(testimonials);

    return testimonials;
}